export default "__VITE_ASSET__429ede0d__"